import script from "./VVVEarlyPayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVEarlyPayModal.vue?vue&type=script&setup=true&lang=js"

import "./VVVEarlyPayModal.vue?vue&type=style&index=0&id=3d5944c2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5944c2"]])

export default __exports__